module.exports = "/images/emptyBasket.svg";